import React from 'react';
import PropTypes from 'prop-types';

import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonList,
  IonItem,
  IonLabel,
  IonNote,
  IonBackButton,
  IonChip,
  IonRow,
  IonCol,
  IonSpinner
} from '@ionic/react';
import { connect } from 'react-redux'

import './InfoUser.css';
import InfoUserActions from '../../../actions/infoUser';
import { RESOURCES } from '../../../constants/system';
import ErrorAlert from '../../../components/ErrorAlert';

interface Props {
  getChild: any;
  data: any;
}

interface ClassState {
  match: any;
  data: any;
}

class InfoUser extends React.Component<Props, ClassState> {
  constructor(props: any) {
    super(props)
    this.state = {data: props.data, match: props.match}
  }

  componentDidMount(){
    if(this.state.data.eva.length === 0){
      this.props.getChild({id: this.state.match.params.child}, "get_child");
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: any){
    this.setState({
      data: nextProps.data,
    });
  }

  render() {
    const { user, error, error401, loading } = this.state.data;
    return (
      <IonPage>
        <ErrorAlert/>
        <IonHeader>
          <IonToolbar color="primary">
            <IonTitle>{ !error && !error401 && user.alumno ? user.alumno : error || error401 ? "Error en la petición":"Cargando..." }</IonTitle>
            <IonButtons slot="start">
              <IonBackButton defaultHref="/progress" />
            </IonButtons>
          </IonToolbar>
          <IonToolbar className="toolbarTint">
            <IonTitle style={ !error && !error401 && user.alumno ? {display: "block"}: {display: "none"}} className="ion-text-center">IB: {user.grado} {user.seccion} - {user.turno}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent fullscreen>
          <h1 style={error || error401 && !loading ? {display: "block"} : {display: "none"}} className="ion-text-center">Error en el sistema, consulte con el administador de la aplicación.</h1>
          <div style={ loading ? {display: "block", paddingTop: '10%'} : {display: "none"}} className="ion-text-center"><IonSpinner name="circles" color="primary"/></div>
          <IonRow class="ion-padding-top" style={!error && !error401 && !loading && user.alumno ? {display: "block"} : {display: "none"}}>
            <IonCol className="ion-align-self-start" size="2"></IonCol>
            <IonCol className="ion-align-self-center">
              <img className="circleImg" alt="" src={`${ RESOURCES }alumnos/${ user.imagen }`} />
            </IonCol>
            <IonCol className="ion-align-self-end" size="2"></IonCol>
          </IonRow>

          <IonList style={!error && !error401 && !loading && user.alumno ? {display: "block"} : {display: "none"}}>
            <IonItem>
              <IonLabel>CARNET</IonLabel>
              <IonNote slot="end" color="primary">{user.carnet}</IonNote>
            </IonItem>

            <IonItem>
              <IonLabel>CODMINED</IonLabel>
              <IonNote slot="end" color="secondary">{user.idmined}</IonNote>
            </IonItem>

            <IonItem>
              <IonLabel>GENERO</IonLabel>
              <IonChip color="danger">
                <IonLabel>{user.genero}</IonLabel>
              </IonChip>
            </IonItem>

            <IonItem>
              <IonLabel>GRADO</IonLabel>
              <IonNote slot="end" color="success">{user.grado}</IonNote>
            </IonItem>

            <IonItem>
              <IonLabel>SECCION</IonLabel>
              <IonNote slot="end" color="warning">{user.seccion}</IonNote>
            </IonItem>

            <IonItem>
              <IonLabel>TURNO</IonLabel>
              <IonNote slot="end" color="danger">{user.turno}</IonNote>
            </IonItem>

            <IonItem>
              <IonLabel>CURSO</IonLabel>
              <IonNote slot="end" color="danger">{user.curso}</IonNote>
            </IonItem>
          </IonList>
        </IonContent>
      </IonPage>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    getChild: PropTypes.func.isRequired,
    data: state.data
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getChild: (fields: any, typeOptions: string) => dispatch(InfoUserActions.getChild(fields, typeOptions)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(InfoUser);
